// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"92":"2b86cd16","221":"194467f3","762":"115df403"}[chunkId] + ".css";
};